import { REQUEST, LIST } from '../../../../redux/ActionType';
import { NEW_JOB_APPLICATIONS } from '../../constants';

export const getNewJobApplications = (params) => ({
    type: REQUEST(LIST(NEW_JOB_APPLICATIONS)),
    payload: { params },
});
